import {
  STBCarouselPlacement,
  STBChannelBannerPlacement,
  STBMoviesAndSeriesBannerPlacement,
  STBDetailBannerPlacement
} from 'redux/reducers/newCampaignReducer'

export function getPlacementCardKey(placement) {
  switch (placement) {
    // Deprecated --->>>
    case 'stb_square_bannar':
      return 'STBSquareBanner'
    case 'stb_main_bannar':
      return 'STBMainBanner'
    // <<<--- End of deprecated

    case 'stb_channel_bannar':
      return 'STBChannelBanner'
    case 'stb_bannar':
      return 'STBBanner'
    case 'stb_half_bannar':
      return 'STBHalfBanner'
    case 'stb_sidebar_bannar':
      return 'STBSidebarBanner'
    case 'stb_popup':
      return 'STBPopup'
    case 'stb_thread':
      return 'STBThread'
    case 'stb_s_ad':
      return 'STBSkippable'
    case 'stb_un_ad':
      return 'STBUnskippable'
    case 'app_bannar':
      return 'AppBanner'
    case 'app_detail_bannar':
      return 'AppDetailBanner'
    case 'app_carousel_ad':
      return 'AppCarouselAd'
    case 'app_popup':
      return 'AppPopup'
    case 'app_thread':
      return 'AppThread'
    case 'app_s_ad':
      return 'AppSkippable'
    case 'app_un_ad':
      return 'AppUnskippable'
    case 'stb_carousel_ad':
      return 'STBCarousel'
    case 'stb_movie_series_bannar':
      return 'STBMoviesAndSeriesBanner'
    case 'stb_detail_bannar':
      return 'STBDetailBanner'
    default:
      return 'STBBanner'
  }
}
export const getPlacementName = (placement) => {
  const placementNames = {
    // Deprecated --->>>
    stb_square_bannar: 'TV - Square Banner',
    stb_main_bannar: 'TV - Main Banner',
    // <<<--- End of deprecated

    stb_channel_bannar: 'TV - Channel Banner',
    stb_bannar: 'TV Banner',
    stb_half_bannar: 'TV - Info Banner',
    stb_sidebar_bannar: 'TV - List Banner',
    stb_popup: 'TV - Pop up',
    stb_thread: 'TV - Thread',
    stb_s_ad: 'TV - Skippable Ad',
    stb_un_ad: 'TV - Unskippable Ad',
    app_bannar: 'App - Banner',
    app_detail_bannar: 'App - Detail Banner',
    app_carousel_ad: 'App - Carousel Ad',
    app_popup: 'App - PopUp',
    app_thread: 'App Thread',
    app_s_ad: 'App Skippable Ad',
    app_un_ad: 'App Unskippable Ad',
    stb_carousel_ad: STBCarouselPlacement.name,
    stb_movie_series_bannar: STBMoviesAndSeriesBannerPlacement.name,
    stb_detail_bannar: STBDetailBannerPlacement.name
  }
  return placementNames[placement] ? placementNames[placement] : 'TV Banner'
}

export const getCardName = (placement) => {
  const names = {
    AppBanner: 'App - Banner',
    STBChannelBanner: STBChannelBannerPlacement.name,
    STBBanner: 'TV Banner',
    STBHalfBanner: 'TV - Info Banner',
    STBSidebarBanner: 'TV - List Banner',
    STBPopup: 'TV - Pop up',
    STBThread: 'TV - Thread',
    STBSkippable: 'TV - Skippable Ad',
    STBUnskippable: 'TV - Unskippable Ad',
    AppDetailBanner: 'App - Detail Banner',
    AppCarouselAd: 'App - Carousel Ad',
    AppPopup: 'App - PopUp',
    AppThread: 'App Thread',
    AppSkippable: 'App - Skippable Ad',
    AppUnskippable: 'App - Unskippable Ad',
    STBCarousel: STBCarouselPlacement.name,
    STBMoviesAndSeriesBanner: STBMoviesAndSeriesBannerPlacement.name,
    STBDetailBanner: STBDetailBannerPlacement.name,

    // Deprecated --->>>
    STBSquareBanner: 'TV - Square Banner',
    STBMainBanner: 'TV - Main Banner'
    // <<<--- End of deprecated
  }
  return names[placement] ? names[placement] : ''
}
